import React from 'react';
import { Button, Popconfirm, Space, Switch } from 'antd';
import {DeleteOutlined} from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { UPDATE_CLIENT } from '../../../graphql/client';
import { UPDATE_PARENT } from '../../../graphql/parent';
import _ from 'lodash';

export default function ClientSkill({ client, type, skill, onUpdate }) {

    const [updateMutation, { loading }] = useMutation(type === 'child' ? UPDATE_CLIENT : UPDATE_PARENT);

    const onSubmit = async (value) => {

        const skills = _.map(client?.attributes?.skill, item => {
            if (item.id === skill.id) {
                return {
                    id: item.id,
                    own: value
                }
            } else {
                return {
                    id: item.id,
                }
            }
        });

        await updateMutation({
            variables: {
                id: client.id,
                data: {
                    skill: skills,
                }
            },
            onCompleted: () => {
                onUpdate();
            }
        })

    };

    const onDelete = async () => {
        const skills = _.map(client?.attributes?.skill, item => ({id: item.id}));
        const filtred = skills.filter(item => item.id !== skill.id);

        await updateMutation({
            variables: {
                id: client.id,
                data: {
                    skill: filtred,
                }
            },
            onCompleted: () => {
                onUpdate();
            }
        })
    }

    return (
        <div className="crm-indicator">
            <div className={'crm-indicator-title'}>
                <Space size={10}>
                    <Switch loading={loading} defaultChecked={skill.own} onChange={onSubmit} />
                    {skill.name}
                </Space>
                <span>
                    <Popconfirm
                        title="Удалить навык"
                        description="Вы уверены что хотите удалить навык?"
                        onConfirm={onDelete}
                        okText="Да"
                        cancelText="Нет"
                    >
                        <Button icon={<DeleteOutlined />} type={'link'} />
                    </Popconfirm>
                </span>
            </div>
        </div>
    );
}